import React, { FC } from "react";
import { MenuItem } from "layout/Menu/MenuItem/MenuItem";

interface IProps {
  menu: Menu[];
  activeLink: string;
  brandingColor: string;
  onHandleMenuItemClick: () => void;
}

const Menu: FC<IProps> = ({ menu, activeLink, brandingColor, onHandleMenuItemClick }) => {
  return (
    <ul className="sidenav-menu">
      {menu?.map((item) => (
        <MenuItem
          item={item}
          activeLink={activeLink}
          brandingColor={brandingColor}
          key={item.value}
          onClick={onHandleMenuItemClick}
        />
      ))}
    </ul>
  );
};

export default Menu;
